import { render, staticRenderFns } from "./arviointityokalut-modal.vue?vue&type=template&id=8c91f752&scoped=true&"
import script from "./arviointityokalut-modal.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalut-modal.vue?vue&type=script&lang=ts&"
import style0 from "./arviointityokalut-modal.vue?vue&type=style&index=0&id=8c91f752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c91f752",
  null
  
)

export default component.exports